import dynamic from 'next/dynamic';

const UsersGrid = dynamic(() => import('./UsersGrid/UsersGrid'));
const UserDetails = dynamic(() => import('./UserDetails/UserDetails'));
const UserDetailsSidebar = dynamic(() =>
  import('./UserDetails/UserDetailsSidebar')
);
const RecentActions = dynamic(() => import('./RecentActions/RecentActions'));
const UserMedia = dynamic(() => import('./UserMedia/UserMedia'));
const AddNewUserModal = dynamic(() => import('./AddNewUserModal'));
const EditUserModal = dynamic(() => import('./EditUserModal/EditUserModal'));

const UserBillingInfos = dynamic(() =>
  import('./UserBillingInfos/UserBillingInfos')
);

const UsersBookingsGrid = dynamic(() =>
  import('./UsersBookingsGrid/UsersBookingsGrid')
);
const CreditScoreForm = dynamic(() =>
  import('./CreditScoreForm/CreditScoreForm')
);
const SubscriberSubsGrid = dynamic(() =>
  import('./SubscriberSubsGrid/SubscriberSubsGrid')
);
const CreateSubscriptionModal = dynamic(() =>
  import('./CreateSubscriptionModal/CreateSubscriptionModal')
);
const AddSubscriptionModal = dynamic(() =>
  import('./AddSubscriptionModal/AddSubscriptionModal')
);
const UserLeasingBuyoutsGrid = dynamic(() =>
  import('./UserLeasingBuyoutsGrid/UserLeasingBuyoutsGrid')
);
const UserB2bGrid = dynamic(() => import('./UserB2bGrid'));
const UserBilling = dynamic(() => import('./UserBilling/UserBilling'));
const UserCreditScore = dynamic(() =>
  import('./UserCreditScore/UserCreditScore')
);
const AddPredelTempSubscriptionModal = dynamic(() =>
  import('./AddPredelTempSubscriptionModal/AddPredelTempSubscriptionModal')
);
const UserSubscriptionAddMenu = dynamic(() =>
  import('./UserSubscriptionAddMenu/UserSubscriptionAddMenu')
);

const UserHistory = dynamic(() => import('./UserHistory/UserHistory'));

export {
  UsersGrid,
  UserDetails,
  UserDetailsSidebar,
  RecentActions,
  UserMedia,
  AddNewUserModal,
  EditUserModal,
  UserBillingInfos,
  UsersBookingsGrid,
  CreditScoreForm,
  SubscriberSubsGrid,
  CreateSubscriptionModal,
  AddSubscriptionModal,
  UserLeasingBuyoutsGrid,
  UserB2bGrid,
  UserBilling,
  UserCreditScore,
  AddPredelTempSubscriptionModal,
  UserSubscriptionAddMenu,
  UserHistory,
};
